(function () {
  const outingEventsTeamsApp = function () {
    const CONTAINER_SELECTOR = '.teams-needing-tee-group, .tee-group-container';
    const DROP_ZONE_ACTIVE_CLASS = 'tee-group-drop-zone-active';

    const bindDragNDrop = () => {
      const containers = $(CONTAINER_SELECTOR).toArray();
      const dropTeeGroups = dragula(containers, {})
        .on('drag', () => $(CONTAINER_SELECTOR).addClass(DROP_ZONE_ACTIVE_CLASS))
        .on('dragend', () => $(CONTAINER_SELECTOR).removeClass(DROP_ZONE_ACTIVE_CLASS))
        .on('drop', (el, target) => {
          $(CONTAINER_SELECTOR).removeClass(DROP_ZONE_ACTIVE_CLASS);
          setTeeGroupTeam(el, target);
        })
        .on('cancel', () => $(CONTAINER_SELECTOR).removeClass(DROP_ZONE_ACTIVE_CLASS));

      window.outingTeeGroupsApp = { dropTeeGroups };
    };

    const setTeeGroupTeam = function (el, target) {
      var $target = $(target);
      var value = $target.hasClass('tee-group-container')
        ? ($target.attr('data-tee-group-id') || $target.data('teeGroupId'))
        : $target.closest('.tee-group-container').length
          ? ($target.closest('.tee-group-container').attr('data-tee-group-id') || $target.closest('.tee-group-container').data('teeGroupId'))
          : '';
      var $el = $(el);
      var $teamInput = $el.find('.team-input');
      var $playerInput = $el.find('.player-input');
      if ($teamInput.length) {
        $teamInput.val(value);
      } else if ($playerInput.length) {
        $playerInput.val(value);
      } else {
        var playerId = $el.data('player-id') || $el.data('playerId');
        if (playerId) {
          $('input[name="players[' + playerId + ']"]').val(value);
        } else {
          var teamId = $el.data('team-id');
          if (teamId) {
            $('input[name="teams[' + teamId + ']"]').val(value);
          }
        }
      }
    };

    const triggerRandomGenerate = function(ajaxUrl) {
      let teamsPerTeeGroup;
      window.swalConfirm.fire({
        text: 'This action will change your current tee groups.'
      }).then(result => {
        if (!result.isConfirmed) return false;

        window.swal.fire({
          title: null,
          text: "How many teams per tee group?",
          input: 'number',
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Auto generate tee groups',
          reverseButtons: true,
          icon: 'info',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-secondary mr-2',
          },
          buttonsStyling: false,
          showConfirmButton: true,
          preConfirm: (result) => {
            if (result && result.length > 0) return (teamsPerTeeGroup = parseInt(result));

            Swal.showValidationMessage('Please enter how many teams per tee group.');
          },
          inputValue: gon.teams_per_tee_group
        }).then((result) => {
          if (!result.isConfirmed) return false;

          $('.generic-loader').removeClass('d-none')
          $.post({
            url: ajaxUrl,
            method: 'POST',
            data: { teams_per_tee_group: teamsPerTeeGroup },
            success: () => window.location.reload(),
          })
        });
      })
    };

    $(document).on('turbolinks:load', () => {
      if (!$('body').hasClass('controller-outings-tee_groups')) return;

      bindDragNDrop();
      $('#auto-generate-tee-groups').on('click', function (e) {
        e.preventDefault();
        $('#auto-generate-modal').modal('show');
      });

      $('#auto-generate-submit').on('click', function () {
        const type = $('input[name="auto_generate_type"]:checked').val();
        const btn = $(this);
        $('#auto-generate-modal').modal('hide');
        if (type === 'match_play') {
          window.swalConfirm.fire({
            text: 'This action will change your current tee groups.'
          }).then(result => {
            if (!result.isConfirmed) return;
            $('.generic-loader').removeClass('d-none');
            $.post({ url: btn.data('match-play-url'), success: () => window.location.reload() });
          });
        } else {
          triggerRandomGenerate(btn.data('random-url'));
        }
      });
    });
  };

  if (typeof window !== 'undefined') {
    window.outingEventsTeamsApp = outingEventsTeamsApp();
  }
})();
